import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@src/components/ui/dialog';
import { GitPanel } from '@src/components/terminal/interactive-terminal/side-windows';
import React from 'react';
import { Trans } from '@lingui/react/macro';

interface GitStatusModalProps {
  open: boolean;
  onClose: () => void;
  computeNodeId: string;
  workdir: string;
  /** Refresh the outer (footer) git status after a push from inside the modal. */
  onPushed?: () => void;
}

/**
 * Opens the existing ``GitPanel`` (status list + per-file diff) as a modal.
 * Reuses the same git-diff screen that lives in the interactive terminal's
 * side window — no separate UI.
 */
export const GitStatusModal: React.FC<GitStatusModalProps> = ({
  open,
  onClose,
  computeNodeId,
  workdir,
  onPushed,
}) => {
  const dialogRef = React.useRef<HTMLDivElement>(null);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent
        ref={dialogRef}
        onOpenAutoFocus={(event) => {
          // Keep focus inside the dialog without opening the first button's tooltip.
          event.preventDefault();
          dialogRef.current?.focus();
        }}
        className="flex flex-col p-0"
        style={{ width: '90vw', maxWidth: '1000px', height: '85vh' }}
      >
        <DialogHeader className="shrink-0 border-b px-4 py-3">
          <DialogTitle className="text-sm font-medium"><Trans>Git changes</Trans></DialogTitle>
        </DialogHeader>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <GitPanel computeNodeId={computeNodeId} workdir={workdir} onPushed={onPushed} onReviewLaunched={onClose} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
